export default {
  'menu.FeedbackRecordNewPage': '新建意见反馈',
}